import { AddTenant } from "./add-tenants";
import { TenantsTable } from "./tenants-table";

export const Tenants = {
  TenantsTable,
  AddTenant
};
